import { useEffect, useState } from 'react'
import { loadPlanCatalog } from '../services/pricingCatalog.service'
import type { SubscriptionPlan } from '../services/subscriptionPlans.service'

export function usePlanCatalog() {
  const [plans, setPlans] = useState<SubscriptionPlan[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    let cancelled = false
    loadPlanCatalog()
      .then((data) => {
        if (!cancelled) {
          setPlans(data)
          setError(null)
        }
      })
      .catch((e: unknown) => {
        if (!cancelled) {
          setError(e instanceof Error ? e : new Error(String(e)))
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  return { plans, loading, error }
}
